<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="上級分類" prop="cateId" >
        <a-tree-select v-if="cateList3.length" v-model="form.cateId" style="width: 100%" :replaceFields="replaceFields"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateList3" placeholder="請選擇上級分類"
          tree-default-expand-all>
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="分類名稱" prop="label">
        <a-input v-model="form.label" placeholder="請輸入" />
      </a-form-model-item>
      <a-form-model-item label="狀態" prop="status" >
        <a-radio-group v-model="status" button-style="solid">
          <a-radio-button v-for="(d, index) in statusOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="顯示順序" prop="postSort" >
        <a-input-number v-model="form.postSort" :min="0" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="分類圖片" prop="images">
        <a-upload action="" list-type="picture-card" :file-list="fileList" @preview="handlePreview"
          @change="uploadImages">
          <div v-if="fileList.length < 1">
            <a-icon type="plus" />
            <div class="ant-upload-text">
              上傳
            </div>
          </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import * as article from '@/api/mall/article'
import { list } from '@/api/mall/articlecate'

import Editor from '@/components/Editor'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: 'CreateForm',
  props: {

  },
  components: {
    Editor
  },
  data() {
    return {
      loading: true,
      submitLoading: false,
      formTitle: '',
      form: {
        pid: '',
        id: 0,
        label: '',
        image: '',
        postSort: 0,
        status: 1,
      },
      replaceFields: {
        title: 'label',
        key: 'id',
        value: 'id',
        children: 'children'
      },
      cateList: [],
      cateList3: [],  // 只有三層的分類
      statusOptions: [
        {
          label: '顯示',
          value: 1
        },
        {
          label: '隱藏',
          value: 0
        }
      ],
      status: 1,
      // 上傳圖片
      open: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      rules: {
        label: [{ required: true, message: '分類名稱不能為空', trigger: 'blur' }],
      },
    }
  },
  filters: {
  },
  created() {
    this.getArticleCate()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 過去文章分類
    getArticleCate() {
      this.loading = false
      this.cateList = [{
        "id": 1,
        "pid": 0,
        "label": "熱門推薦",
        "image": "",
        "sort": 0,
        "status": 1,
        "children": [
          {
            "id": 20,
            "pid": 1,
            "label": "新聞動態",
            "image": "",
            "sort": 0,
            "status": 1
          },
          {
            "id": 21,
            "pid": 1,
            "label": "最新熱點",
            "image": "",
            "sort": 0,
            "status": 1,
            "children": [
              {
                "id": 22,
                "pid": 21,
                "label": "熱點1",
                "image": "",
                "sort": 0,
                "status": 1
              },{
                "id": 23,
                "pid": 21,
                "label": "熱點2",
                "image": "",
                "sort": 0,
                "status": 1
              }
            ]
          }
        ]
      },
      {
        "id": 2,
        "pid": 0,
        "label": "APP問題",
        "image": "",
        "sort": 0,
        "status": 1,
        "children": []
      }]
      return
      list.then(res => {

      }).catch(err => {

      })
    },
    onClose() {
      this.open = false
    },
    // 取消按鈕
    cancel() {
      this.open = false
      this.reset()
    },
    // 表單重置
    reset() {
      this.form = {
        title: '',
        subTitle: '',
        content: '',
        author: '',
        images: [],
        postSort: 0,
        status: 1,
        cateId: undefined
      }
    },
    /** 新增按鈕操作 */
    handleAdd() {
      this.formTitle = '添加分類'
      this.reset()
      this.open = true
      // 拉平分類數據
      // this.cateList
      console.log('分類數據', this.cateList)
      let arr = []
      let arr3 = JSON.parse(JSON.stringify(this.cateList))
      arr3.map((item)=>{
        if(item.children && item.children.length) {
          item.children.map(item1=>{
            if(item1.children && item1.children.length) {
              delete item1.children
            }
          })
        }
      })
      console.log('arr3', arr3)
      this.cateList3 = arr3
      console.log('cateList3', this.cateList3)
    },
    /** 修改按鈕操作 */
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      this.open = true
      this.formTitle = '修改分類'
      return
      article.detail({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改分類'
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 上傳圖片
    uploadImages({ fileList }) {
      console.log('fileList', fileList)
      this.fileList = fileList
    },
    /** 提交按鈕 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.postId !== undefined) {
            console.log('form', this.form)
            return
            updatePost(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            console.log('form', this.form)
            console.log('上傳的封面圖', this.fileList)
            this.form.images = this.fileList
            return
            addPost(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
